<script setup>
defineProps({
  title: { type: String, required: true },
  titleId: String,
  fullSizeTitle: Boolean,
  backTo: { type: String, default: '/profile' },
  backLabel: { type: String, default: 'Назад в Профиль' },
})
</script>

<template>
  <header class="profile-page-header">
    <div v-if="$slots.default" class="profile-page-meta"><slot /></div>
    <div class="profile-page-heading">
      <button type="button" class="profile-page-back" :aria-label="backLabel" @click="$router.push(backTo)">
        <svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
      </button>
      <h1 :id="titleId" :class="{ 'long-title': !fullSizeTitle && title.length > 20 }">{{ title }}</h1>
    </div>
  </header>
</template>

<style scoped>
.profile-page-header { margin-bottom: 20px; color: var(--ink); }
.profile-page-heading { display: flex; align-items: center; gap: 8px; }
.profile-page-back { display: flex; align-items: center; justify-content: center; flex: none; width: 44px; height: 44px; margin-left: -10px; border-radius: 12px; }
.profile-page-back:active { background: var(--ink-10); }
.profile-page-back:focus-visible { outline: 2px solid var(--ink); outline-offset: 2px; }
h1 { min-width: 0; margin: 0; font-size: var(--fs-22); font-weight: 700; line-height: 1.2; }
h1.long-title { font-size: clamp(var(--fs-16), 5vw, var(--fs-22)); }
.profile-page-meta { margin-bottom: 4px; text-align: right; font-size: var(--fs-11); line-height: 1.4; color: var(--ink-70); }
</style>
